import io from 'socket.io-client';

const SFU_URL = process.env.REACT_APP_SFU_URL || 'https://myclass.vskul.com:3002';

class WebRTCService {
  constructor() {
    this.socket = null;
    this.localStream = null;
    this.listeners = {};
  }

  async getLocalStream() {
    try {
      this.localStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });
      return this.localStream;
    } catch (error) {
      console.error('Error getting local stream:', error);
      throw error;
    }
  }

  async connect(token) {
    console.log('Connecting to SFU at:', SFU_URL);
    this.socket = io(SFU_URL, {
      auth: { token },
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 10,
      transports: ['websocket', 'polling'],
      secure: true,
      rejectUnauthorized: false,
      withCredentials: true,
      forceNew: true,
    });

    return new Promise((resolve, reject) => {
      this.socket.on('connect', () => {
        console.log('Socket connected:', this.socket.id);
        this.emit('connected', { socketId: this.socket.id });
        resolve();
      });
      this.socket.on('disconnect', () => {
        console.log('Socket disconnected');
        this.emit('disconnected');
      });
      this.socket.on('error', (error) => {
        console.error('Socket error:', error);
        this.emit('error', error);
      });
      this.socket.on('connect_error', (error) => {
        console.error('Connection error:', error);
        reject(error);
      });
      setTimeout(() => {
        if (!this.socket?.connected) {
          reject(new Error('Socket connection timeout'));
        }
      }, 10000);
    });
  }

  stopLocalStream() {
    if (this.localStream) {
      this.localStream.getTracks().forEach((track) => track.stop());
      this.localStream = null;
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
    this.stopLocalStream();
  }

  toggleAudio(enabled) {
    if (this.localStream) {
      this.localStream.getAudioTracks().forEach((track) => {
        track.enabled = enabled;
      });
    }
  }

  toggleVideo(enabled) {
    if (this.localStream) {
      this.localStream.getVideoTracks().forEach((track) => {
        track.enabled = enabled;
      });
    }
  }

  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach((callback) => callback(data));
    }
  }
}

export const webrtcService = new WebRTCService();
export default webrtcService;
